(function () {

  'use strict';

  eclipseApp.directive('rgUsageDial', function () {
    return {
      restrict: 'E',
      scope: true,
      replace: true,
      templateUrl: 'modules/core/views/usage-dial.html'

    };
  });

})();

